import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompMotorComp({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] =useState('Guardar Informacion')
  const [infoMotorComplement, setInfoCompFluids] = useState({
    strap_accessories: 0,
    Gas_Gasoline_Conversion: 0,
    Radiator: 0,
    Engine_Mounts: 0,
    AC_compressor: 0,
    Bonnet_Trunk_Shock_Absorbers: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'MC', data: infoMotorComplement });
  });

  const handleForm = ({ target }) => {
    const tmpMotorComplement = { ...infoMotorComplement, [target.name]: target.value }
    setInfoCompFluids(tmpMotorComplement);
    autosave.schedule();
    //generalUpdate('infoMotorComplement', tmpMotorComplement)

  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get( `/peritaje/infostate/C` ,  {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data
      const currentDefaultState = stateapp.find((e)=> e.name.toLowerCase()==='bueno');
      setInfoCompFluids({
        strap_accessories:currentDefaultState.id,
        Gas_Gasoline_Conversion:currentDefaultState.id,
        Radiator:currentDefaultState.id,
        Engine_Mounts:currentDefaultState.id,
        AC_compressor:currentDefaultState.id,
        Bonnet_Trunk_Shock_Absorbers:currentDefaultState.id,
      });
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = {type:'MC', data :infoMotorComplement};
    const respo = await post('/peritaje/modifyinspection/components/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'MC' };
      const tmpMotor = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const {detail} = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpMotor[element.name] = element.id_state;
        }
        if(detail.length>0) setInfoCompFluids(tmpMotor);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner />  : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">COMPLEMENTOS DE MOTOR</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="strap_accessories">Correa Accesorios</Form.Label>
          <Form.Select
            name="strap_accessories"
            value={infoMotorComplement.strap_accessories}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Gas_Gasoline_Conversion">Conversion Gas Gasolina</Form.Label>
          <Form.Select
            name="Gas_Gasoline_Conversion"
            value={infoMotorComplement.Gas_Gasoline_Conversion}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Radiator">Radiador</Form.Label>
          <Form.Select
            name="Radiator"
            value={infoMotorComplement.Radiator}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Engine_Mounts">Soportes Motor</Form.Label>
          <Form.Select
            name="Engine_Mounts"
            value={infoMotorComplement.Engine_Mounts}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="AC_compressor">Compresor de A/A</Form.Label>
          <Form.Select
            name="AC_compressor"
            value={infoMotorComplement.AC_compressor}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Bonnet_Trunk_Shock_Absorbers">Amortiguadores Capot Baul</Form.Label>
          <Form.Select
            name="Bonnet_Trunk_Shock_Absorbers"
            value={infoMotorComplement.Bonnet_Trunk_Shock_Absorbers}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
          {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompMotorComp;
